// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__13C78","options":"AnswerScale_options__3OBIb","selected":"AnswerScale_selected__2tan8"};